export const getTooltipText = (
  value: string | null = "",
  lengthToShow = 28,
) => {
  if (!value) return "";
  if (value?.length >= lengthToShow) {
    return value;
  }
};
